import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dbm-box-list',
    template: require('./dbm-box-list.component.html'),
    styles: [require('./dbm-box-list.component.scss')]
})
export class DbmBoxListComponent {
    @Input() public listItems: any;
    @Output() public onListItemDelete = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-box-list/dbm-box-list.component.ts